<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "ReportsView",
  mounted() {
    this.$store.state.tabs = [
      // {
      //   text: `${this.$t("summary")}`,
      //   to: "/",
      // },
      {
        text: this.$t("current_shift"),
        to: "/current",
      },
      {
        text: this.$t("history"),
        to: "/reports/history",
      },
      {
        text: this.$t("detail_chart_tv"),
        to: "/reports/chart-tv",
      },
      {
        text: this.$t("analytics"),
        to: "/reports/analytics",
      },
    ];
  },
};
</script>
